import { toast } from "@/hooks/useToast"

export async function getDeviceInfo() {
  const devices = await navigator.mediaDevices.enumerateDevices()

  return {
    audioInputDevices: devices.filter((device) => device.kind === "audioinput"),
    videoInputDevices: devices.filter((device) => device.kind === "videoinput"),
    audioOutputDevices: devices.filter((device) => device.kind === "audiooutput"),
    hasAudioInputDevices: devices.some((device) => device.kind === "audioinput"),
    hasVideoInputDevices: devices.some((device) => device.kind === "videoinput"),
  }
}

// This function will return 'true' when the specified permission has been denied by the user.
// If the API doesn't exist, or the query function returns an error, 'false' will be returned.
export const isPermissionDenied = (permissionName: "camera" | "microphone"): Promise<boolean> => {
  return navigator.mediaDevices
    .getUserMedia({ video: permissionName === "camera", audio: permissionName === "microphone" })
    .then(() => {
      return false
    })
    .catch(() => {
      return true
    })
}

export const permissionDeniedToast = (isCameraPermissionDenied: boolean, isMicrophonePermissionDenied: boolean) => {
  if (isCameraPermissionDenied && isMicrophonePermissionDenied) {
    toast({ description: "Camera and microphone permission denied" })
    return
  }
  if (isCameraPermissionDenied) {
    toast({ description: "Camera permission denied" })
    return
  }

  if (isMicrophonePermissionDenied) {
    toast({ description: "Microphone permission denied" })
  }
}
